import { useQuery } from '@tanstack/react-query';
import { MakeModelOption } from '../../MakeModelKeywordSearch.typed';
import { searchPageApi } from '../../../../api/searchPageApi';
import extractMakeOptions from '../../extractMakesFromSearchFilters';

export default function usePopularAndAllMakes({
  minPrice,
  maxPrice,
  minYear,
  maxYear,
  initialData,
}: {
  minPrice?: string;
  maxPrice?: string;
  minYear?: string;
  maxYear?: string;
  initialData: Array<MakeModelOption>;
}) {
  const isPristine =
    minPrice === undefined &&
    maxPrice === undefined &&
    minYear === undefined &&
    maxYear === undefined;

  return useQuery({
    queryKey: ['popularAndAllMakes', { minPrice, maxPrice, minYear, maxYear }],
    initialData: isPristine ? initialData : undefined,
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: async () => {
      const ranges = [];
      if (minPrice || maxPrice) {
        ranges.push({ name: 'price', from: minPrice, to: maxPrice });
      }
      if (minYear || maxYear) {
        ranges.push({ name: 'year', from: minYear, to: maxYear });
      }
      const response = await searchPageApi.getCarsFiltersWithCount(undefined, {
        ranges,
      });
      return extractMakeOptions(response.data.showByDefault);
    },
  });
}
